import { Faq } from "../components/Faq";
import { FinalCta, Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { JournalSection } from "../components/JournalSection";
import { Journey } from "../components/Journey";
import { ValidationSection } from "../components/ValidationSection";
import { WaterOrigin } from "../components/WaterOrigin";

export function HomePage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <WaterOrigin />
        <Journey />
        <ValidationSection />
        <JournalSection />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </>
  );
}

